export default __webpack_public_path__ + "static/media/gallery41.44fa1999.webp";